import React, { Component } from 'react'
import { connect } from 'react-redux'

import SwitchButton from '../switch-button/SwitchButton'
import StepButton from '../step-button/StepButton'
import BackButton from '../back-button/BackButton'
import SmartInput from '../smart-input/SmartInput'
import ProgressBar from '../progressbar/ProgressBar'

import { getNames } from '../../actions/ContentActions'

class SettingsScreen extends Component {
  static defaultProps = {
    genders: [],
    textTypes: [],
    names: []
  }

  constructor(props) {
    super(props)
    this.state = {
      postcard: JSON.parse(localStorage.getItem('postcard'))
    }
  }

  componentWillMount() {
    this.handleGenderChange(this.state.postcard.gender, 10);
  }

  handleGenderChange = (gender) => {
    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    if(localPostcard.gender !== gender) {
      localPostcard.gender = gender
      localPostcard.startPhrase = ''
      localPostcard.name = ''
    }

    this.setState({
      postcard: localPostcard
    })

    localStorage.setItem('postcard', JSON.stringify(localPostcard));

    this.props.dispatch(getNames(gender))
  }

  handleTextTypeChange = (type) => {
    this.setState({
      postcard: {
        ...this.state.postcard,
        type: type
      }
    }) 

    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.type = type

    // ATTENTION!!! HARCODE!!!
    if(type === 2) localPostcard.text = 17
    else localPostcard.text = 1

    localStorage.setItem('postcard', JSON.stringify(localPostcard));
  }

  handleStartPhraseChange = (newValue) => {
    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.startPhrase = newValue

    localStorage.setItem('postcard', JSON.stringify(localPostcard));
  }

  handleNameChange = (newValue) => {
    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.name = newValue

    localStorage.setItem('postcard', JSON.stringify(localPostcard));
  }

  render() {
    const { genders, textTypes, names, referer } = this.props
    const { postcard } = this.state

    var defaultStart = ''
    if(postcard.startPhrase !== '') {
      defaultStart = postcard.startPhrase
    }
    else {
      defaultStart = (names.startPhrases) ? names.startPhrases[0].value : ''
    }

    var defaultName = ''
    if(postcard.name !== '') {
      defaultName = postcard.name
    }
    else {
      defaultName = (names.names) ? names.names[0].value : ''
    }

    return (
      
      <div>
        <ProgressBar step="1" reverse={(referer.action !== "PUSH") ? 'reverse' : 'normal'}/>

        <h1 className="blue">Ты уже решил, кого поздравишь?</h1>
        <p>Любимую бабушку, бесценного коллегу или незаменимого<br/> губернатора - поздравь их всех!</p>
        <SwitchButton selected={postcard.gender} items={genders} onValueChanged={this.handleGenderChange} />

        <SmartInput 
          tips={names.startPhrases} 
          placeholder="Введите обращение"
          onValueChanged={this.handleStartPhraseChange} /> 

        <SmartInput 
          tips={names.names} 
          placeholder="Введите имя"
          onValueChanged={this.handleNameChange} />

        <h2 className="blue">Тип поздравления</h2>
        <SwitchButton selected={postcard.type} items={textTypes} onValueChanged={this.handleTextTypeChange} />
        
        <div className="buttons-row">
          <BackButton title="Назад"/>        
          <StepButton small={true} title="Продолжить" icon={true} navigateTo="text"/>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  textTypes: state.staticContent.data.textTypes,
  genders: state.staticContent.data.genders,
  names: state.names.data,
  referer: state.routing.locationBeforeTransitions
}))(SettingsScreen)



// WEBPACK FOOTER //
// ./src/components/postcard/SettingsScreen.js